<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title float-left"> Регион</h4>
                        <router-link tag="button" class="btn btn-success float-right" to="/user/new">Добавить
                        </router-link>
                    </div>
                    <div class="card-body table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th width="20%">ФИО</th>
                                    <th width="10%">Логин</th>
                                    <th width="10%">E-Mail</th>
                                    <th width="10%">Телефон</th>
                                    <th width="15%">Роль</th>
                                    <th width="5%">Активный</th>
                                    <th width="15%" class="d-none d-md-table-cell">Создано</th>
                                    <th width="15%" class="d-none d-md-table-cell">Обновлено</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                                <tr v-for="result in results.data" :key="result.id">
                                    <td>{{result.firstName}} {{result.lastName}}</td>
                                    <td>{{result.username}}</td>
                                    <td>{{result.email}}</td>
                                    <td>{{result.phone}}</td>
                                    <td>
                                        <div v-for="role in result.roles" :key="role" style="margin: 3px">
                                            <span v-if="role==='ROLE_ADMIN'">Администратор</span>
                                            <span v-else-if="role==='ROLE_DISPATCHER'">Диспетчер</span>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="form-check pl-0">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="checkbox" v-model="result.activated" disabled>
                                                <span class="form-check-sign"></span>
                                            </label>
                                        </div>
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <div v-if="result.createdBy">{{result.createdBy.name}}</div>
                                        <div v-if="result.createdDate">{{result.createdDate}}</div>
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <div v-if="result.updatedBy">{{result.updatedBy.name}}</div>
                                        <div v-if="result.updatedDate">{{result.updatedDate}}</div>
                                    </td>
                                    <td>
                                        <div class="btn-group btn-group-sm">
                                            <router-link :to="'/user/edit/' + result.id" tag="button" class="btn btn-info">
                                                <i class="fa fa-pencil"></i>
                                            </router-link>
                                            <button class="btn btn-danger" @click="deleteDialog(result)" v-if="!result.system">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">Нет данных</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.pageCount && results.pageCount > 1 ">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page" :per-page="filter.pageSize" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import {BPagination} from 'bootstrap-vue';

    import FilterModel from './../../shared/filter';

    export default {
        name: "UserList",
        components: {
            'b-pagination': BPagination
        },
        data() {
            return {
                loading: false,
                filter: new FilterModel(),
                results: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.get('user', this.filter.asQuery())
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page = page;
                this.initList();
            },
            deleteUser(user) {
                this.$http.delete('user/' + user.id)
                    .then(() => {
                        this.initList();
                    }, () => {
                        this.$swal({
                            title: 'Ошибка',
                            text: 'Ошибка при удалении пользователь',
                            type: 'error'
                        });
                    });
            },
            deleteDialog(item) {
                this.$swal({
                    title: 'Удалить?',
                    text: 'Вы действительно хотите удалить этот пользователь?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Отменить',
                    confirmButtonColor: '#E5343D'
                }).then((result) => {
                    if (result.value) {
                        this.deleteUser(item);
                    }
                });
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>